import React, { useContext, useEffect, useState } from 'react'
import { TestContext } from '../../../utils/context'
import styles from '../styles.module.scss'
import _ from 'lodash'
import { getQuestionsFile } from '../../../actions/testing'
import { useDispatch, useSelector } from 'react-redux'
import { openCarousel } from '../../../actions/carousel'
import Loader from "react-loader";
import Checkbox from '../../../assets/CustomCheckbox/CustomCheckbox'
import { createNotification } from '../../notifications/notifications'


const MultichoiceQuestion = ({visible, question, setQuestionPassed}) => {
  
  const {addQuestionAnswer, nextQuestion, closeTestHandler, testId, navPanel, finishTest, timeOver} = useContext(TestContext)
  
  const dispatch = useDispatch()
  const {data: filesData, loading} = useSelector(state => state.testing.files)
  useEffect(() => {
    const filesRequested = filesData.hasOwnProperty(question.question_id)
    if (question.question_id && visible && !filesRequested) dispatch(getQuestionsFile(question.question_id))
  }, [visible])

  const [answers, setAnswers] = useState([])

  useEffect(() => {
    if (timeOver) return;
    const withCorrectField = question.answers.map(answer => ({...answer, correct: false}))
    // const answers = _.shuffle(withCorrectField)
    setAnswers(withCorrectField)
  }, [timeOver])

  const files = filesData[question.question_id]

  const renderAnswer = (answer, index) => (
    <Checkbox
      onClick={selectAnswerHandler(index)}
      label={answer.answer_text}
      checked={answer.correct}
      color='#a52a2a'
    />
  )
  
  const sendAnswerHandler = async () => {
    const hasSelected = answers.some(({correct}) => correct)
    if (!hasSelected) return createNotification('error', 'Выберите хотя бы один вариант ответа')
    const payload = answers.filter(({correct}) => !!correct).map((answer) => ({ answer_id: answer.id }))
    const success = await addQuestionAnswer(testId, question.question_id, payload)
    if (!success) return;
    setQuestionPassed()
    nextQuestion()
  }

  const selectAnswerHandler = (index) => () => {
    const newAnswers = JSON.parse(JSON.stringify(answers))
    newAnswers[index].correct = !newAnswers[index].correct
    setAnswers(newAnswers)
  }

  const renderFile = (file, ind) => (
    <img
      onClick={openCarouselHandler(ind)}
      type={file?.mime}
      src={`data:image/jpeg;base64,${file?.content}`}
      key={file?.name}
      alt={file?.name}
    />
  )

  const openCarouselHandler = (initialSlide) => () => {
    const images = files.map(file => `data:image/jpeg;base64,${file.content}`)
    dispatch(openCarousel({images, initialSlide}))
  }

  return (
    <div style={{display: visible ? 'block' : 'none'}}>
      <div className={styles.multichoiceQuestion}>
        <p className={styles.taskTitle}>{question.question_text}</p>
        <div className={styles.files}>
          {
            loading
              ? <Loader/>
              : !!files?.length && files.map(renderFile)
          }
        </div>
        <div>{answers.map(renderAnswer)}</div>
      </div>
      {navPanel}
      <div className={styles.buttonsBlock}>
        <button onClick={sendAnswerHandler}>Ответить</button>
        <button onClick={finishTest}>Завершить</button>
      </div>
    </div>
  )
}

export default MultichoiceQuestion